import React, { useEffect, useState } from 'react';
import Button from '../../../../../component/ui/Button';
import General from './components/general';
import PreferencesGeneralFieldCustomisation from './components/PreferencesGeneralFieldCustomisation';
import { toast } from 'react-toastify';
import {
	getPreferencesGeneral,
	UpdatePreferencesGeneral,
} from '../../../../../services/settings/preferences';
import { stringToBool } from '../../../../../utils/utility';

export default function PreferencesGeneral({ activeTab }) {
	const [tab, setTab] = useState('General');
	const [isEdit, setIsEdit] = useState(false);
	const [isCreateForm, setIsCreateForm] = useState(false);
	const [generalLoader, setGeneralLoader] = useState({
		isLoader: true,
		isSave: false,
		isGetData: true,
		isGetDataFieldCustomisation: true,
		isSaveFieldCustomisation: true,
	});
	const [customFieldError, setCustomFieldError] = useState(false);
	const [error, setError] = useState(false);
	const [customFieldForm, setCustomFieldForm] = useState({
		label_name: '',
		data_type: '',
		status: false,
		is_mandatory: false,
	});
	const [general, setGeneral] = useState({});
	const [form, setForm] = useState({
		discount_preferences: '',
		email_attachments: false,
		round_off_preferences: '',
		enable_sales_person: false,
	});

	const getShowUndoChanged = () => {
		const hasChanged = JSON.stringify(general) !== JSON.stringify(form);
		setIsEdit(hasChanged);
	};

	useEffect(() => {
		if (form) {
			getShowUndoChanged();
		}
	}, [form]);

	const handleGeneral = async () => {
		try {
			setIsEdit(false);
			setGeneralLoader((prev) => ({
				...prev,
				isLoader: true,
				isSave: true,
			}));
			const res = await UpdatePreferencesGeneral(form);
			if (res.success) {
				toast.success(res.message);
				getGeneralDetails();
			} else {
				setIsEdit(true);
				toast.error(res.message || 'something went wrong!');
			}
		} catch (error) {
			setIsEdit(true);
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setGeneralLoader((prev) => ({
				...prev,
				isLoader: false,
				isSave: false,
			}));
		}
	};
	const handleCustomField = () => {};

	const getGeneralDetails = async () => {
		try {
			const { general_settings } = await getPreferencesGeneral();

			const data = {
				discount_preferences:
					general_settings.discount_preferences !== null
						? general_settings.discount_preferences
						: '',
				email_attachments:
					general_settings.email_attachments !== null
						? stringToBool(general_settings.email_attachments)
						: false,
				round_off_preferences:
					general_settings.round_off_preferences !== null
						? general_settings.round_off_preferences
						: '',
				enable_sales_person:
					general_settings.enable_sales_person !== null
						? stringToBool(general_settings.enable_sales_person)
						: false,
			};
			setForm(data);
			setGeneral(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setGeneralLoader((prev) => ({
				...prev,
				isLoader: false,
				isGetData: false,
			}));
		}
	};

	useEffect(() => {
		getGeneralDetails();
	}, []);

	return (
		<div>
			<div style={{ backgroundColor: '#EDEDF7', position: 'sticky', top: 0, zIndex: 100 }}>
				<div className="d-flex py-3 px-2 justify-content-between align-items-center">
					<div className="fs-4 fw-semibold">{activeTab}</div>
					<div className="d-flex gap-3">
						{tab === 'Field Customisation' ? (
							<Button
								type="button"
								className="mt-0 btn-primary fs-5 fw-light add-pro py-1"
								button="Add New Custom Field"
								add
								onClick={() => setIsCreateForm(true)}
							/>
						) : (
							<>
								<Button
									type="button"
									className="btn-primary mt-0 fs-5 fw-light add-pro py-1 px-4"
									button="Save"
									disabled={!isEdit}
									onClick={() => handleGeneral()}
									loader={generalLoader.isLoader && generalLoader.isSave}
								/>
								{isEdit && (
									<Button
										type="button"
										className="btn-primary mt-0 fs-5 fw-light add-pro py-1 px-4"
										button="Undo Changed"
										onClick={() => {
											setIsEdit(false);
											getGeneralDetails();
										}}
									/>
								)}
							</>
						)}
					</div>
				</div>
			</div>
			<div
				className="py-2 d-flex justify-content-between align-items-center"
				style={{ backgroundColor: '#DADDEC', position: 'sticky', top: 0, zIndex: 100 }}
			>
				<div>
					<ul className="nav mt-2">
						{['General', 'Field Customisation'].map((item, index) => (
							<li
								key={index}
								className="nav-item"
							>
								<div
									className={`tab-link ${tab === item ? 'active' : ''} d-flex align-items-center`}
									onClick={() => {
										setTab(item);
										setIsCreateForm(false);
									}}
								>
									{item}
								</div>
							</li>
						))}
					</ul>
				</div>
				{isCreateForm && (
					<div className="d-flex gap-4 align-items-center px-2">
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#0066ff' }}
							onClick={() => handleCustomField()}
						>
							Save
						</div>
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#555B67' }}
							onClick={() => setIsCreateForm(false)}
						>
							Cancel
						</div>
					</div>
				)}
			</div>
			{tab === 'General' ? (
				<General
					form={form}
					setForm={setForm}
					error={error}
					setError={setError}
					generalLoader={generalLoader}
				/>
			) : (
				<PreferencesGeneralFieldCustomisation
					isCreateForm={isCreateForm}
					setIsCreateForm={setIsCreateForm}
					setCustomFieldForm={setCustomFieldForm}
					customFieldForm={customFieldForm}
					setCustomFieldError={setCustomFieldError}
					customFieldError={customFieldError}
				/>
			)}
		</div>
	);
}
